"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var slate_react_1 = require("slate-react");
var EditorTypes_1 = require("../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var WidgetActions = __importStar(require("./WidgetActions"));
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var ButtonActions_1 = require("./ButtonActions");
exports.default = (function (di) {
    var editorTelemetry = di.get("editorTelemetry");
    return {
        onUpdateButton: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("updateButtonWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "update" })
            .doAction(function (event, editor) {
            (0, ButtonActions_1.updateButtonWidget)(editor, event.data.path, event.data.toUpdate);
            return true;
        }),
        onDeleteButton: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("deleteButtonWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "delete" })
            .doAction(function (event, editor) {
            WidgetActions.removeWidget(editor, event.data.path);
            editorTelemetry.inlineContentDeleted(EditorTypes_1.BlockType.Button);
            return true;
        }),
        onDeleteBefore: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("deleteKeyBeforeButtonWidget")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Delete)
            .inBlockType(EditorTypes_1.BlockType.Any)
            .atEndOfBlock()
            .selectionIsCollapsed()
            .hasBlockAfter(EditorTypes_1.BlockType.Button)
            .doAction(function (event, editor) {
            if (!editor.selection) {
                return;
            }
            event.preventDefault();
            var nextTextEntry = (0, Utils_1.getNext)(editor, editor.selection.anchor.path, slate_1.Text.isText);
            if (!nextTextEntry) {
                return;
            }
            slate_1.Transforms.select(editor, { path: nextTextEntry[1], offset: 0 });
            return true;
        }),
        onBackspaceAfter: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("backspaceKeyAfterButtonWidget")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Backspace)
            .inBlockType(EditorTypes_1.BlockType.Any)
            .atStartOfBlock()
            .selectionIsCollapsed()
            .hasBlockAfter(EditorTypes_1.BlockType.Button)
            .doAction(function (event, editor) {
            if (!editor.selection) {
                return;
            }
            event.preventDefault();
            var previousTextEntry = (0, Utils_1.getPrevious)(editor, editor.selection.anchor.path, slate_1.Text.isText);
            if (!previousTextEntry) {
                return;
            }
            slate_1.Transforms.select(editor, { path: previousTextEntry[1], offset: 0 });
            return true;
        }),
        onManualButtonSelect: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("manualButtonSelect")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "select" })
            .doAction(function (event, editor) {
            var path = event.data.path;
            slate_1.Transforms.select(editor, { path: path, offset: 0 });
            return true;
        }),
        onArrowDownWhenButtonFocused: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("buttonArrowDown")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowDown)
            .inBlockType(EditorTypes_1.BlockType.Button)
            .doAction(function (event, editor) {
            event.preventDefault();
            var button = (0, Utils_1.checkSelfAndAncestors)(editor, editor.selection.anchor.path, function (x) { return x.type === EditorTypes_1.BlockType.Button; });
            if (button) {
                var path = button[1];
                (0, ButtonActions_1.updateButtonWidget)(editor, path, { autoFocus: true });
                return true;
            }
        }),
        onArrowUpWhenButtonFocused: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("buttonArrowUp")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.ArrowUp)
            .inBlockType(EditorTypes_1.BlockType.Button)
            .doAction(function (event, editor) {
            event.preventDefault();
            var button = (0, Utils_1.checkSelfAndAncestors)(editor, editor.selection.anchor.path, function (x) { return x.type === EditorTypes_1.BlockType.Button; });
            slate_1.Transforms.select(editor, { path: button[1], offset: 0 });
            (0, Utils_1.moveToEndOfPreviousText)(editor);
            slate_react_1.ReactEditor.focus(editor);
            return true;
        }),
        onEnterInLabel: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("buttonEnterInLabel")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "addParagraphBelow" })
            .doAction(function (event, editor) {
            slate_1.Transforms.select(editor, event.data.path);
            WidgetActions.newParagraphBelowWidget(editor);
            slate_react_1.ReactEditor.focus(editor);
            return true;
        }),
        onArrowDownInLabel: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("buttonArrowDownInLabel")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "arrowDownInLabel" })
            .doAction(function (event, editor) {
            var path = event.data.path;
            slate_1.Transforms.select(editor, { path: path, offset: 0 });
            (0, Utils_1.moveToStartOfNextText)(editor);
            slate_react_1.ReactEditor.focus(editor);
            return true;
        }),
        onArrowUpInLabel: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("buttonArrowUpInLabel")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "button", action: "arrowUpInLabel" })
            .doAction(function (event, editor) {
            var path = event.data.path;
            slate_1.Transforms.select(editor, { path: path, offset: 0 });
            slate_react_1.ReactEditor.focus(editor);
            return true;
        }),
    };
});
